import Vue from 'vue'
import axios from 'axios'
import router from '@/router/index.js'
import { setStore, getStore, removeStore, getStoreSession, removeStoreSession, getUrlParams} from '@/utils/utils.js'
import config from '@/config/config.js'
axios.defaults.baseURL = config.baseURL
axios.defaults.timeout = 60000
axios.defaults.headers = {
    //"Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    "Content-Type": "application/json"
}
// 正常登录请求
let normalAxios = axios.create({
    baseURL: config.baseURL,
    timeout: 60000,
    headers: { "Content-Type": "application/json" }
});

// 临时邀请人员请求
let meetingAxios = axios.create({
    baseURL: config.baseURL,
    timeout: 60000,
    headers: { "Content-Type": "application/json" }
});

//刷新token的请求方法
const getRefreshToken = () => {
    let data = {
        refreshToken: getStore('refreshToken')
    };
    //qs的使用主要是因为该接口需要表单提交的方式传数据，具体使用方法自行百度
    return axios.post("/gzzc/user/refreshToken", data);
}

//添加一个请求拦截器
normalAxios.interceptors.request.use(axiosconfig => {
    //在请求发送之前做一些事
    let deviceID = getStore('deviceId')
    const isHasToken=!!getStore('flk');
    // 认证令牌
    if (getStoreSession('haslogin') == 'yes' ||isHasToken) {
        const flk = getStore('flk');
        axiosconfig.headers.JWTToken = flk;
    }
    axiosconfig.headers.deviceId = deviceID
    axiosconfig.headers.cType = "PC"
    axiosconfig.headers.appName = getStore('appName') ? getStore('appName'): "gzzc"

    return axiosconfig
}, error => {
    Vue.prototype.$message({
        showClose: true,
        message: error,
        type: 'error'
    });
    return Promise.reject(error)
})

meetingAxios.interceptors.request.use(axiosconfig => {
    //在请求发送之前做一些事
    let deviceID = getStore('deviceId')
        // 认证令牌
    const flk = getStore('otherToken');
    axiosconfig.headers.JWTToken = flk;
    axiosconfig.headers.deviceId = deviceID
    axiosconfig.headers.cType = "PC"

    axiosconfig.headers.appName = getStore('appName') ? getStore('appName') : "gzzc"

    return axiosconfig
}, error => {
    Vue.prototype.$message({
        showClose: true,
        message: error,
        type: 'error'
    });
    return Promise.reject(error)
})

//添加一个返回拦截器
normalAxios.interceptors.response.use(response => {
    //对响应数据做些事
    if (response.data.code === 1002) {
        let config = response.config;
        return getRefreshToken()
            .then(function(res) {
                let data = res.data;
                if (data.code === 1000) {
                    setStore('flk', data.data.flk);
                    setStore('refreshToken', data.data.refreshToken);
                    //修改原请求的token
                    let flk = getStore('flk');
                    config.headers.JWTToken = flk;
                    /*这边不需要baseURL是因为会重新请求url
                     *url中已经包含baseURL的部分了
                     *如果不修改成空字符串，会变成'api/api/xxxx'的情况*/
                    config.baseURL = '';
                    //重新请求
                    return axios(config).then(
                        (responsedata) => {
                            console.log("重发上一次请求")
                            return responsedata
                        }
                    ).catch(
                        (response) => {
                            console.log("未渲染成功")
                            return response
                        });
                } else {
                    Vue.prototype.$message({ showClose: true, message: '超时退出', type: 'warning' });
                    removeStore('flk');
                    if (getStore('loginInfo')) {
                        setStore('loginCurrTab', 1);
                    }
                    removeStore('refreshToken');
                    removeStore('loginInfo');
                    removeStore('loginInfouser');
                    removeStore('loginInfoEnterprise');
                    removeStoreSession('haslogin');
                    router.push({ path: '/login' })
                    return { data: { code: '1001' } }
                }
            });

    } else if (response.data.code === 1001) {
        Vue.prototype.$message({ showClose: true, message: '超时退出', type: 'warning' });
        if (getStore('loginInfo')) {
            setStore('loginCurrTab', 1);
        }
        removeStore('flk');
        removeStore('refreshToken');
        removeStore('loginInfo');
        removeStore('loginInfouser');
        removeStore('loginInfoEnterprise');
        removeStoreSession('haslogin');
        router.push({ path: '/login' })
        return { data: { code: '1001' } }
    } else {
        return response
    }
}, error => {
    // 下面是接口回调的satus ,因为我做了一些错误页面,所以都会指向对应的报错页面
    if (error.response.status === 403) {
        router.push({
            path: "/error/403"
        });
    }
    if (error.response.status === 500) {
        router.push({
            path: "/error/500"
        });
    }
    if (error.response.status === 502) {
        router.push({
            path: "/error/502"
        });
    }
    if (error.response.status === 404) {
        // router.push({
        //     path: "/error/404"
        // });
    }
    return Promise.resolve(error.response)
})

//错误处理
function errorState(response) {
    // 如果http状态码正常，则直接返回数据
    if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
        return response
            // 如果不需要除了data之外的数据，可以直接 return response.data
    } else {
        Vue.prototype.$message({
            showClose: true,
            message: '网络异常',
            type: 'error'
        });
    }

}

function successState(res) {
    //统一判断后端返回的错误码
    if (res.data.code == '9999') {
        Vue.prototype.$message({
            showClose: true,
            message: '9999-服务器内部异常/网络异常',
            type: 'error'
        });
    }
}

export const http = (opts, data) => {
    let httpDefaultOpts = { //http默认配置
        method: opts.method || "post",
        url: opts.url
    }

    if (opts.method == 'get') {
        httpDefaultOpts.params = data
    } else {
        httpDefaultOpts.data = data
    }
    let promise = new Promise(function(resolve, reject) {
        normalAxios(httpDefaultOpts).then(
            (res) => {
                successState(res)
                resolve(res)
            }
        ).catch(
            (response) => {
                errorState(response)
                reject(response)
            }
        )
    })
    return promise
}
export const meetingHttp = (opts, data) => {
    let httpDefaultOpts = { //http默认配置
        method: opts.method || "post",
        url: opts.url
    }

    if (opts.method == 'get') {
        httpDefaultOpts.params = data
    } else {
        httpDefaultOpts.data = data
    }

    let promise = new Promise(function(resolve, reject) {
        meetingAxios(httpDefaultOpts).then(
            (res) => {
                successState(res)
                resolve(res)
            }
        ).catch(
            (response) => {
                errorState(response)
                reject(response)
            }
        )
    })
    return promise
}
